import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { CustomEase } from "gsap/CustomEase";

gsap.registerPlugin(ScrollSmoother, CustomEase);

export default function initGsap() {
    gsap.defaults({
        ease: CustomEase.create("cubic", "M0,0 C0.77,0, 0.18,1, 1,1"),
    });

    gsap.config({
        force3D: true,
    });

    if (MNK) {
        ScrollSmoother.create({
            smooth: 0,
            effects: true,
            // effectsPadding: 400,
        });
    }

    // if (MNK) {
    // const smoother = ScrollSmoother.create({
    //     // smooth: 1.2,
    //     effects: true,
    //     effectsPadding: 1000,
    // });
    // }

    // if (MNK) {
    //     ["show.bs.modal", "show.bs.offcanvas"].forEach((event) =>
    //         document.addEventListener(event, () => smoother.paused(true))
    //     );

    //     ["hide.bs.modal", "hide.bs.offcanvas"].forEach((event) =>
    //         document.addEventListener(event, () => smoother.paused(false))
    //     );
    // }

    // if (MNK) {
    //     ScrollTrigger.normalizeScroll({
    //         allowNestedScroll: true,
    //     });
    // }
}
